import React from "react";
import { observer } from "mobx-react";
import { PaymentReceiptCreateStore } from "../../store";
import { PaymentReceiptBatchCreateForm } from "./PaymentReceiptBatchCreateForm";
import { ErrorDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";

export type PaymentReceiptBatchCreateProps = {
  paymentReceiptCreateStore: PaymentReceiptCreateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const PaymentReceiptBatchCreate: React.FC<PaymentReceiptBatchCreateProps> =
  observer(
    ({ paymentReceiptCreateStore, showToolbox = true, showSaveFooter }) => {
      return (
        <>
          <SavingOverlay open={paymentReceiptCreateStore.isSaving} />
          <PaymentReceiptBatchCreateForm
            paymentReceiptCreateStore={paymentReceiptCreateStore}
            typeError={paymentReceiptCreateStore.errors.type?.message}
            onTypeChange={(value) => {
              paymentReceiptCreateStore.setTypeValue(value);
            }}
            typeSelectedValue={paymentReceiptCreateStore.entityValues.showType}
            onTypeSelected={(value) => {
              paymentReceiptCreateStore.setSelectedType(value);
            }}
            typeOptions={paymentReceiptCreateStore.getTypeOptions()}
            amountError={paymentReceiptCreateStore.errors.amount?.message}
            onAmountChange={(value: number) => {
              paymentReceiptCreateStore.setAmountValue(value);
            }}
            amount={paymentReceiptCreateStore.entityValues.amount}
            issueDateTimeError={
              paymentReceiptCreateStore.errors.issueDateTime?.message
            }
            onIssueDateTimeChange={(value) => {
              paymentReceiptCreateStore.setIssueDateTimeValue(value);
            }}
            issueDateTime={paymentReceiptCreateStore.entityValues.issueDateTime}
            showToolbox={showToolbox}
            showSaveFooter={showSaveFooter}
            saving={paymentReceiptCreateStore.isProcessing}
            onSave={() => paymentReceiptCreateStore.saveNewPaymentReceipt()}
            onCancel={() => paymentReceiptCreateStore.cancelNewPaymentReceipt()}
          />
          <ErrorDialog
            open={paymentReceiptCreateStore.errorDialogOpened}
            title={paymentReceiptCreateStore.errorTitle}
            description={paymentReceiptCreateStore.errorDescription}
            onClose={() => paymentReceiptCreateStore.closeErrorDialog()}
          />
        </>
      );
    }
  );
